import React from "react";
import "./Home.css";

const Home = () => {
  const links = [
    { 
      path: "/laws/index.html", 
      title: "Law", 
      icon: "/icons/server.svg" 
    },
    { 
      path: "/coding/index.html", 
      title: "Coding", 
      icon: "/icons/server.svg" 
    }
  ];

  return (
    <div className="home-container">
      <div className="icon-column">
        {links.map((link, index) => (
          <a
            key={index}
            href={link.path}
            className="icon-link"
            title={link.title}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={link.icon} alt={`${link.title} Folder`} className="icon" />
            <span className="icon-title">{link.title}</span>
          </a>
        ))}
      </div>
      <div className="main-content">
        <h1>Welcome to My Portfolio</h1>
        <blockquote>
          <p>
            "Hold on to what inspires you, even if it exists only in your dreams. 
            For in nurturing that spark, you keep alive the possibility of change. 
            To let it go is to surrender not just the dream, but the very chance 
            of making it real. The world shifts when you refuse to give up on what 
            sets your soul on fire."
          </p>
        </blockquote>
        <p>
          <a
            href="https://medium.com/@mmahindaratne88"
            target="_blank"
            rel="noopener noreferrer"
            className="medium-link"
          >
            Follow me on Medium
          </a>
        </p>
      </div>
    </div>
  );
};

export default Home;